var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouTubeColorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3765_3421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.6099 12.8031C47.3325 11.7781 46.7915 10.8436 46.0407 10.0927C45.2898 9.34188 44.3554 8.8008 43.3304 8.5234C39.578 7.5 24.4755 7.5 24.4755 7.5C24.4755 7.5 9.37235 7.53098 5.61988 8.55438C4.59487 8.8318 3.66043 9.3729 2.9096 10.1238C2.15876 10.8747 1.61774 11.8092 1.34041 12.8342C0.20538 19.5016 -0.23492 29.6612 1.37158 36.0619C1.64894 37.0869 2.18997 38.0213 2.9408 38.7722C3.69163 39.5231 4.62606 40.0641 5.65105 40.3415C9.40351 41.3649 24.5063 41.3649 24.5063 41.3649C24.5063 41.3649 39.6089 41.3649 43.3612 40.3415C44.3862 40.0642 45.3207 39.5231 46.0716 38.7722C46.8224 38.0214 47.3635 37.0869 47.6409 36.0619C48.838 29.385 49.2069 19.2317 47.6099 12.8031Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.668 31.689L32.1966 24.4323L19.668 17.1755V31.689Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3765_3421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubeColorLogo);
export default __webpack_public_path__ + "static/media/YouTubeColorLogo.cc161dc25a98562ba91a53b81fd07060.svg";
export { ForwardRef as ReactComponent };